// extracted by mini-css-extract-plugin
module.exports = {"wrap":"game-type_wrap_2pPLR","selectedItem":"game-type_selectedItem_1L1Kg"};